var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
export const Hotkey = props => {
    var _a, _b, _c, _d;
    const { children, className, variant, size = 'md' } = props, rest = __rest(props, ["children", "className", "variant", "size"]);
    if (!children) {
        return null;
    }
    const keys = (_d = (_c = (_b = (_a = children === null || children === void 0 ? void 0 : children.toString()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.split(',')) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.split('+');
    if (!keys || !keys.length) {
        return null;
    }
    const mapping = {
        shift: '⇧',
        control: 'Ctrl',
        command: '⌘',
        cmd: '⌘',
        option: '⌥',
        alt: 'Alt',
        esc: 'Esc',
        backspace: '⌫',
    };
    return (React.createElement("span", Object.assign({}, rest, { className: clsx('hotkey inline-flex flex-nowrap text-content-subdued', size !== 'sm' && 'space-s-0.5', className) }), keys.map(key => (React.createElement("kbd", { className: clsx('font-sans justify-center inline-flex', size === 'sm' && 'text-xs', !mapping[key] && 'uppercase', variant === 'key' &&
            'text-xs items-center rounded-md bg-surface-subdued h-5 w-5 border border-line-subdued shadow-sm'), key: key }, mapping[key] || key)))));
};
//# sourceMappingURL=Hotkey.js.map